import Range from '@/modules/common/components/form/range'

export default class RangeFilter {
  range: Range | null = null
}
